import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/core/services/config.service';

@Component({
    selector: 'app-unauthorize-page',
    templateUrl: './unauthorize-page.component.html',
    styleUrls: ['./unauthorize-page.component.scss', '../error-page/error-page.component.scss'],
    standalone: false
})
export class UnauthorizePageComponent implements OnInit {

  supportEmail: string;
  constructor(private configService: ConfigService) { }

  ngOnInit(): void {
    this.supportEmail = this.configService.supportEmail;
  }

}
